<script lang="ts">
  import type { SharedOrder } from "@shared/types/Order";
  import type { CartOrderType } from "@shared/types/Cart";

  export let order: CartOrderType | SharedOrder;
  export let background: string = "fizz-surface-gray";
  export let padding: number = 16;

  $: paddingClass = " fizz-inset-square-" + padding;

</script>

<style>
  .fizz-flow-4 {
    word-break: break-word;
  }

</style>

{#if order.retailer_notes || order.backup_notes}
  <div
    data-testid="notes-container"
    class={"fizz-text-medium fizz-flow-4 fizz-radius-medium " + background + paddingClass}
  >
    {#if order.retailer_notes}
      <p>
        <strong>Note: </strong>
        {order.retailer_notes}
      </p>
    {/if}
    {#if order.backup_notes}
      <p>
        <strong>Backup instructions: </strong>
        {order.backup_notes}
      </p>
    {/if}
  </div>
{/if}
